import { createTheme as e } from "@mui/material/styles";
const f = e({
  palette: {
    text: {
      primary: "#ffffff"
    }
  },
  typography: {
    allVariants: {
      color: "#ffffff"
    },
    fontFamily: "var(--font-Roboto)"
  },
  breakpoints: {
    values: {
      res320: 320,
      res480: 480,
      res768: 768,
      res1024: 1024,
      res1280: 1280,
      res1600: 1600,
      res1920: 1920,
      res3440: 3440
    }
  }
});
export {
  f as default
};
//# sourceMappingURL=theme.js.map
